import { Injectable } from '@angular/core';
import {
  ConnectionBackend,
  RequestOptions,
  Request,
  RequestOptionsArgs,
  Response,
  Http,
  Headers
} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BusyService } from './busy.service';
import { environment } from '../../../environments/environment';
import { AlertService } from './alert.service';
import { UserFriendlyErrorService } from './user-friendly-error.service';
import { tokenStorage } from '../core/tokenStorage';
import { Router } from '@angular/router';

@Injectable()
export class InterceptedHttp extends Http {
  constructor(
    backend: ConnectionBackend,
    defaultOptions: RequestOptions,
    private alertService: AlertService,
    private busyService: BusyService,
    private userFriendlyErrorService: UserFriendlyErrorService,
    private router: Router
  ) {
    super(backend, defaultOptions);
  }

  private getAuthorizationHeaderValue() {
    if (tokenStorage.getItem('currentUser')) {
      const user = JSON.parse(tokenStorage.getItem('currentUser'));
      return 'Bearer ' + user.token;
    }
    return null;
  }

  request(
    url: string | Request,
    options?: RequestOptionsArgs
  ): Observable<Response> {
    return super.request(url, options);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    url = this.updateUrl(url);

    const observable = super
      .get(url, this.getRequestOptionArgs(options))
      .share();
    this.subscribeOnError(observable, url);

    return observable;
  }

  post(
    url: string,
    body: string,
    options?: RequestOptionsArgs
  ): Observable<Response> {
    url = this.updateUrl(url);

    const observable = super
      .post(url, body, this.getRequestOptionArgs(options))
      .share();
    this.subscribeOnError(observable, url);

    return observable;
  }

  put(
    url: string,
    body: string,
    options?: RequestOptionsArgs
  ): Observable<Response> {
    url = this.updateUrl(url);

    const observable = super
      .put(url, body, this.getRequestOptionArgs(options))
      .share();
    this.subscribeOnError(observable, url);

    return observable;
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    url = this.updateUrl(url);
    const observable = super
      .delete(url, this.getRequestOptionArgs(options))
      .share();
    this.subscribeOnError(observable, url);

    return observable;
  }

  private updateUrl(req: string) {
    if (!req.trim().startsWith('http')) {
      return environment.api + req;
    }
    return req;
  }

  private subscribeOnError(obs: Observable<Response>, url: string) {
    obs.subscribe(
      res => {
        if (res.headers.keys().indexOf('authorization') >= 0) {
          const token = res.headers.get('authorization');
          tokenStorage.extendLife('currentUser', token);
        }
      },
      err => {
        if (err && err.status === 401) {
          this.router.navigate(['/login']);
        } else {
          let errorMessage = this.userFriendlyErrorService.getErrorMessage(url);
          let json: any = {};
          if (!!err.text()) {
            json = err.json();
          } else {
            json.message = err.status + ' ' + err.statusText;
          }
          if (err && json && json.message) {
            errorMessage += this.userFriendlyErrorService.buidlDetailsPart(
              json.message
            );
          }
          setTimeout(() => {
            this.alertService.showError(errorMessage, 'Error');
          }, 100);
        }
      }
    );
  }

  private getRequestOptionArgs(
    options?: RequestOptionsArgs
  ): RequestOptionsArgs {
    if (options == null) {
      options = new RequestOptions();
    }
    if (options.headers == null) {
      options.headers = new Headers();
    }

    if (this.getAuthorizationHeaderValue() != null) {
      options.headers.append(
        'Authorization',
        this.getAuthorizationHeaderValue()
      );
    }

    // options.headers.append('Content-Type', 'application/json');
    options.headers.append('Accept', 'application/json;');
    options.headers.append('Cache-Control', 'no-cache;');
    options.headers.append('Pragma', 'no-cache;');
    options.headers.append(
      'If-Modified-Since',
      'Sat, 01 Jan 2000 00:00:00 GMT;'
    );

    return options;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/http.interceptor.ts